export type HorizontalScrollThumbMetrics = {
  left: number;
  width: number;
};

/**
 * Thumb size and offset for a custom horizontal scrollbar, in the coordinate
 * space of a track as wide as {@link visibleWidth}. Returns `null` when
 * {@link contentWidth} fits in {@link visibleWidth}.
 */
export const horizontalScrollThumbMetrics = (
  scrollLeft: number,
  visibleWidth: number,
  contentWidth: number,
  minThumbWidthPx: number,
): HorizontalScrollThumbMetrics | null => {
  if (contentWidth <= visibleWidth) return null;
  const width = Math.max(
    (visibleWidth / contentWidth) * visibleWidth,
    minThumbWidthPx,
  );
  const maxScroll = contentWidth - visibleWidth;
  const maxLeft = visibleWidth - width;
  const left = maxLeft <= 0 ? 0 : (scrollLeft / maxScroll) * maxLeft;
  return { left, width };
};

/**
 * `scrollLeft` that places the thumb at {@link thumbLeft} inside the track.
 */
export const scrollLeftFromThumbLeft = (
  thumbLeft: number,
  thumbWidth: number,
  visibleWidth: number,
  contentWidth: number,
): number => {
  const maxScroll = contentWidth - visibleWidth;
  const maxLeft = visibleWidth - thumbWidth;
  if (maxScroll <= 0 || maxLeft <= 0) return 0;
  const clamped = Math.min(Math.max(thumbLeft, 0), maxLeft);
  return (clamped / maxLeft) * maxScroll;
};
